import * as React from 'react';

import * as styles from './footer.css';

export class Footer extends React.PureComponent<{}, {}> {
  render() {
    return (
      <div className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.footerContent}>
            <small>
              The names "Goldman Sachs," and "Marquee" are the trademarks or registered trademarks
              of Goldman Sachs. © 2019 Goldman Sachs & Co. LLC. All rights reserved. Descriptions of
              the products and services available through the Marquee platform provided herein are
              for educational purposes only and do not reflect all information that may be relevant
              in determining whether use of any such product or service is suitable for your
              circumstances. Goldman Sachs is not recommending that you take any action based on any
              information presented herein, which may be updated or modified form time-to-time by
              Goldman Sachs in its sole discretion without prior notice or subsequent notification.
              Prior to utilizing product or service available through the Marquee platform, you
              should read carefully any related disclosure provided by Goldman Sachs, including any
              information to which you may be required to agree and acknowledge or any user
              agreements that you may be required to execute, and make an independent determination
              regarding the suitability of your use of the relevant product or service.
            </small>
          </div>
        </div>
      </div>
    );
  }
}
